// Facebook-like background gradients shared by text stories and text posts.
export const BG_GRADIENTS = [
  { key: "blue", css: "linear-gradient(160deg,#1E6FEB,#7FC1FF)" },
  { key: "purple", css: "linear-gradient(160deg,#7B2FF7,#F107A3)" },
  { key: "sunset", css: "linear-gradient(160deg,#F5AF19,#F12711)" },
  { key: "rose", css: "linear-gradient(160deg,#E0475F,#F7A6B9)" },
  { key: "navy", css: "linear-gradient(160deg,#0F2027,#2C5364)" },
  { key: "black", css: "linear-gradient(160deg,#232526,#414345)" },
  { key: "green", css: "linear-gradient(160deg,#11998E,#38EF7D)" },
  { key: "coral", css: "linear-gradient(160deg,#D97757,#F2C46D)" },
  { key: "violet", css: "linear-gradient(160deg,#41295A,#752F97)" },
  { key: "pink", css: "linear-gradient(160deg,#EC008C,#FC6767)" },
  { key: "ocean", css: "linear-gradient(160deg,#00C6FF,#0072FF)" },
  { key: "gold", css: "linear-gradient(160deg,#B8860B,#FFD700)" },
];

// Thèmes « couleur d'accent » d'une église (mêmes teintes que les affiches de partage) → fond de story `accent:<clé>`.
export const ACCENT_THEMES = {
  foret: ["#1c3a2c", "#0E1A14", "#070d0a"],
  or: ["#5a4413", "#241a06", "#0c0900"],
  nuit: ["#1e2a4a", "#0d1226", "#05070f"],
  royal: ["#3a1f52", "#1b0f2b", "#0a0512"],
  aurore: ["#0f3f45", "#0a2126", "#04100f"],
};
export const accentGradientCss = (accentKey) => {
  const st = ACCENT_THEMES[accentKey];
  return st ? `linear-gradient(160deg, ${st[0]} 0%, ${st[1]} 55%, ${st[2]} 100%)` : null;
};

// Teinte d'un hex vers le noir (pct < 0) ou le blanc (pct > 0) — fonds « assortis » à une photo.
export const shadeHex = (hex, pct) => {
  const m = /^#?([0-9a-f]{6})$/i.exec(String(hex || ""));
  if (!m) return hex;
  const n = parseInt(m[1], 16);
  const mix = (c) => Math.round(pct < 0 ? c * (1 + pct / 100) : c + (255 - c) * (pct / 100));
  const r = mix((n >> 16) & 255), g = mix((n >> 8) & 255), b = mix(n & 255);
  return `#${((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1)}`;
};
// Fond `hex:#RRGGBB` (couleur dominante d'une photo) → dégradé sombre → couleur → clair.
export const hexGradientCss = (hex) => (/^#[0-9a-f]{6}$/i.test(hex || "")
  ? `linear-gradient(160deg, ${shadeHex(hex, -38)} 0%, ${hex} 55%, ${shadeHex(hex, 18)} 100%)`
  : null);

export const gradientCss = (key) => {
  const g = BG_GRADIENTS.find((x) => x.key === key);
  if (g) return g.css;
  if (typeof key === "string" && key.startsWith("accent:")) return accentGradientCss(key.slice(7));
  if (typeof key === "string" && key.startsWith("hex:")) return hexGradientCss(key.slice(4));
  return null;
};

// Illustrated photo backgrounds for text posts (same art as story/verse backgrounds).
export const BG_IMAGES = [
  { key: "img:sunrise", url: "/verse-bg/sunrise.jpg", label: "Aube" },
  { key: "img:dove", url: "/verse-bg/dove.jpg", label: "Colombe" },
  { key: "img:stars", url: "/verse-bg/stars.jpg", label: "Étoiles" },
  { key: "img:wheat", url: "/verse-bg/wheat.jpg", label: "Blé" },
];

export const bgImageUrl = (key) => (BG_IMAGES.find((b) => b.key === key) || {}).url || null;

// Unified inline style for a bg key (photo OR gradient). Returns null if unknown.
export const bgStyle = (key) => {
  const img = bgImageUrl(key);
  if (img) return { backgroundImage: `url(${img})`, backgroundSize: "cover", backgroundPosition: "center" };
  const g = gradientCss(key);
  return g ? { background: g } : null;
};

// Fond d'une story texte : image illustrée (/verse-bg/* ou clé img:*) sinon dégradé (clé, accent:*, hex:*).
export const storyBgStyle = (bg) => {
  const img = bg && bg.startsWith("/verse-bg/") ? bg : bgImageUrl(bg);
  if (img) return { backgroundImage: `url(${img})`, backgroundSize: "cover", backgroundPosition: "center" };
  return { background: gradientCss(bg) || "var(--gradient-navy)" };
};
